/**
 * @generated SignedSource<<c8703b20a4ccb153074e4f809443537e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignTxnNatureInputObject = {
  expenseNatureId?: string | null | undefined;
  txnIds: ReadonlyArray<string>;
};
export type stakeholderTxnsDialog_AssignTxnNatureMutation$variables = {
  input: AssignTxnNatureInputObject;
};
export type stakeholderTxnsDialog_AssignTxnNatureMutation$data = {
  readonly assignTxnNature: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type stakeholderTxnsDialog_AssignTxnNatureMutation = {
  response: stakeholderTxnsDialog_AssignTxnNatureMutation$data;
  variables: stakeholderTxnsDialog_AssignTxnNatureMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stakeholderTxnsDialog_AssignTxnNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stakeholderTxnsDialog_AssignTxnNatureMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AssignTxnNatureMutationPayload",
        "kind": "LinkedField",
        "name": "assignTxnNature",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e0eb102445ecf0a63ba9eae563a93516",
    "id": null,
    "metadata": {},
    "name": "stakeholderTxnsDialog_AssignTxnNatureMutation",
    "operationKind": "mutation",
    "text": "mutation stakeholderTxnsDialog_AssignTxnNatureMutation(\n  $input: AssignTxnNatureInputObject!\n) {\n  assignTxnNature(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "558d99879ca99927016f5e1c8887af23";

export default node;
